<template>
  <NIndicator indicator="solid-red" ping>
    <NAvatar label="PR" />
  </NIndicator>
</template>
